module.exports = __webpack_public_path__ + "img/1-9.41a2a017.png";